import React from 'react';
import './SelectBar.scss'
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

const SelectBar = ({options = [], onSelect = ()=>{}, ...props}) => {
    const hasActiveOption = options.some(option => option.active === true);
    return (
        <div className='select-bar' {...props}>
            {options.filter(option=>option.display !== false).map((option, i)=>{
                return (
                    <div key={i} onClick={()=>onSelect(option)} className={classNames('select-bar-option', {active : hasActiveOption ? option.active : !i})}>
                       {option.label}
                    </div>
                )
            })}
        </div>
    );
};

export const SelectNavBar = ({children, ...props}) => {
    return (
        <div className='select-bar' {...props}>
            {children}
        </div>
    );
};

export const SelectNavBarItem = ({children, active, ...props}) => {
    return (
        <NavLink className="select-bar-option" {...props}>
            {children}
        </NavLink>
    );
}


export default SelectBar;
